'use strict'

let definition=require('../../definition/labels/norwegian.js').norwegian;
let quality=require('../../quality/labels/norwegian.js').norwegian;
let plan=require('../../plan/labels/norwegian.js').norwegian;
let businessCase=require('../../businessCase/labels/norwegian.js').norwegian;
let org=require('../../organization/labels/norwegian.js').norwegian;

export let norwegian={
  menu: {
    reportActions: "Rapportvalg",
    viewFullScreen: "Vis i fullskjerm",
    tableView: "Vis med tabelloppsett",
    reportView: "Vis med rapportoppsett",
    viewPDF: "Vis som PDF",
    viewWord: "Last ned som Word (docx)",
    viewSlideMode: "Vis som lysbilde",
    createDraft: "Opprett utkast",
    updateDraft: "Oppdater utkast",
    approve: "Godkjenn",
    documentArchive: "Dokumentarkiv",
    current: "Gjeldende",
    draft: "utkast",
    briefDetailsIsFollowedUpInPID: "Ingen endringer vil bli oppdatert i dette Prosjektforslaget, da et Styringsdokument er påbegynt."
  },
  brief: {
    title: "Prosjektforslag",
    messagePreview: "Forhåndsvisning",
    messageDraft: "Utkast",
    frontPage: "Forside"
  },
  definition: {
    title: "Prosjektdefinisjon",
    background: {
      title: definition.background.title
    },
    objectives: {
      title: definition.objectives.title,
      aspects: definition.aspects,
      columns: { // definition.objectives.fields.objectivesSummary.columns
        name: { title: "Område" },
        description: { title: "Beskrivelse" },
        tolerance:  definition.objectives.fields.objectivesSummary.columns.tolerance
      },
    },
    scope: {
      title: definition.scope.title,
      outcomes: definition.scope.fields.outcomes,
      excluded: definition.scope.fields.scopeExclusions
    },
    constraints: {
      title: definition.constraints.fields.constraints.title
    },
    assumptions: {
      title: definition.constraints.fields.assumptions.title
    },
    stakeholders: {
      title: definition.stakeholders.fields.stakeholderDescription.title
    },
    interfaces: {
      title: definition.stakeholders.fields.interfaces.title
    }
  },
  businessCase: {
    title: "Begrunnelse",
    executiveSummary: businessCase.summary.fields.executiveSummary.title,
    reasons: businessCase.strategy.fields.reasons.title,
    doNothing: businessCase.options.fields.doNothing.title,
    doMinimal: businessCase.options.fields.doMinimal.title,
    doSomething: businessCase.options.fields.doSomething.title,
    benefits: {
      title: businessCase.benefits.fields.benefits.title,
      columns: businessCase.benefits.fields.benefits.columns
    },
    projectPlanSummary: businessCase.returnOnInvestment.fields.projectPlanSummary.title,
    investmentAppraisal: businessCase.returnOnInvestment.fields.investmentAppraisal.title,
    risks: businessCase.returnOnInvestment.fields.risks.title
  },
  projectProductDescription: {
    title: "Leveranser",
    noOutputs: "Ingen leveranser er definert.",
    columns: quality.projectProductDescription.fields.scopeDetails.columns
  },
  approach: {
    title: "Prosjekttilnærming",
    methods: plan.planApproach.fields.methods.title,
    resources: plan.planApproach.fields.resources.title,
    technology: plan.planApproach.fields.technology.title,
    rollOut: plan.planApproach.fields.rollOut.title,
    other: plan.planApproach.fields.other.title
  },
  organization: {
    title: "Organisering",
    columns: {
      name: "Navn",
      role: "Rolle",
      description: "Beskrivelse"
    },
    executive: org.roles.project.executive,
    seniorUser: org.roles.project.seniorUser,
    seniorSupplier: org.roles.project.seniorSupplier,
    businessAssurance: org.roles.project.businessAssurance,
    projectManager: org.roles.project.projectManager,
    teamManager: org.roles.project.teamManager,
    projectSupport: org.roles.project.projectSupport,
    changeAuthority: org.roles.project.changeAuthority,
    stakeholder: org.roles.project.stakeholder,
    userAssurance: org.roles.project.userAssurance,
    supplierAssurance: org.roles.project.supplierAssurance,
    teamMember: org.roles.project.teamMember
  },
  approval: {
    fields: {
      approvedBy: {
        title: "Godkjent av",
        description: "Beskriv av hvem og når dokumentet ble godkjent"
      }
    },
    cancel: "Avbryt",
    approve: "Godkjenn prosjektforslaget",
    thisFieldIsRequired: "Dette feltet er påkrevd."
  }
};



// WEBPACK FOOTER //
// ./views/brief/labels/norwegian.js